export default "__VITE_ASSET__43032423__"